import { BrowserRouter, Routes, Route } from "react-router-dom";

import FeedbackModule from "./Service/Feedback/FeedbackModule";
import CloudRouterModule from "./Service/CloudRouter/CloudRouterModule";
import { Homepage } from "./screens";

function WebModule() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/feedback/:id" element={<FeedbackModule />} />
        <Route path="*" element={<CloudRouterModule />} />
      </Routes>
    </BrowserRouter>
  );
}

export default WebModule;
